// extracted by mini-css-extract-plugin
export var standaloneTable = "_gi-0";
export var standaloneTableWithBodyFill = "_gi-1";
export var withExtraHeader = "_gi-2";